function stringToDate(dateTime) {
    if(dateTime === "" || dateTime === "—") return null;
	if(!dateTime.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/)) return NaN;
	let ISOdate = dateTime.split(" ").join("T");
	return Date.parse(ISOdate);
}

export default stringToDate;